/**
 * Titan coming product card — relocate the Stoq button into the info area.
 *
 * On cards for products tagged `upcoming-product` the waitlist call to action is
 * the Stoq (Restock Rocket) button the app injects into each <product-card> at
 * runtime. We surface it inside `.titan-coming-stoq-wrapper`, directly below the
 * product title, instead of leaving it as base.css's hover-reveal overlay.
 *
 * The button is only MOVED within its own <product-card>, so it stays a
 * descendant of the `[data-discord-link]` wrapper and the existing
 * stoq-discord-redirect.js context tracking keeps working. Its behaviour and
 * click handling are untouched; styling is handled by
 * titan-coming-product-card.css. No Stoq code is called or patched.
 *
 * titan-stoq-collection-position.js skips these cards (it looks for
 * `.titan-coming-info`), so the two scripts never fight over the same button.
 *
 * Stoq injects asynchronously at an unknown time, so we run on DOM ready, watch
 * for late injection with a MutationObserver, and re-run on theme-editor
 * section loads. Relocation is idempotent.
 */
(function () {
  'use strict';

  var BUTTON_SELECTOR = '.restock-rocket-button-collection, [class*="restock-rocket-button"]';

  function relocate() {
    var wrappers = document.querySelectorAll('.titan-coming-stoq-wrapper');
    if (!wrappers.length) return;

    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      var card = wrapper.closest('product-card');
      if (!card) continue;

      var button = card.querySelector(BUTTON_SELECTOR);
      // Move only if found and not already living in this wrapper.
      if (button && !wrapper.contains(button)) {
        wrapper.appendChild(button);
      }
    }
  }

  function init() {
    relocate();

    // Catch Stoq's asynchronous injection (and any later re-render that moves
    // the button back out). relocate() is a cheap no-op once the button is
    // already in place.
    if (typeof MutationObserver === 'function') {
      var observer = new MutationObserver(function (mutations) {
        var shouldRun = false;
        for (var i = 0; i < mutations.length && !shouldRun; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.matches(BUTTON_SELECTOR) || node.querySelector(BUTTON_SELECTOR)) {
              shouldRun = true;
              break;
            }
          }
        }
        if (shouldRun) relocate();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    // Fallback ticks in case the observer is unavailable or misses early frames.
    setTimeout(relocate, 800);
    setTimeout(relocate, 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-run when a section is re-rendered.
  document.addEventListener('shopify:section:load', relocate);
})();
